import { useState } from "react";
import { Helmet } from "react-helmet";
import { ChakraProvider } from "@chakra-ui/react";
import Footer from "../../components/Footer";
import { ScrollProgressBar } from "../../components/motion";
import { bobContent, BobLang } from "../../data/bobContent";
import { bobTheme } from "../../theme";
import BobHeader from "./BobHeader";
import BobHero from "./BobHero";
import BobDemo from "./BobDemo";
import BobAudience from "./BobAudience";
import BobValue from "./BobValue";
import BobFAQ from "./BobFAQ";
import BobContactCTA from "./BobContactCTA";

// English is a client-side toggle on this one URL rather than a separate
// /bob/en route (deliberate trade-off — see the BOB plan): Helmet below
// always describes the Hungarian version, since that's what a crawler
// actually receives at this URL. The BOB-specific structured data for
// non-JS crawlers lives statically in public/index.html, same as Wobble/
// SupportMe.
const BobPage = () => {
  const [lang, setLang] = useState<BobLang>("hu");
  const content = bobContent[lang];

  return (
    <>
      <Helmet>
        <html lang="hu" />
        <title>{bobContent.hu.meta.title}</title>
        <meta name="description" content={bobContent.hu.meta.description} />
        <link rel="canonical" href="https://millerproductions.hu/bob" />
        <meta property="og:title" content={bobContent.hu.meta.ogTitle} />
        <meta property="og:description" content={bobContent.hu.meta.ogDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://millerproductions.hu/bob" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={bobContent.hu.meta.ogTitle} />
        <meta name="twitter:description" content={bobContent.hu.meta.ogDescription} />
      </Helmet>
      {/* BOB gets its own nested theme (Lato body copy, the app's real
          navy/teal palette) so it reads as its own product rather than a
          Miller Productions page with a teal accent — see src/theme.js. */}
      <ChakraProvider theme={bobTheme}>
        <ScrollProgressBar color="bob.300" />
        <BobHeader lang={lang} onLangChange={setLang} ctaLabel={content.hero.ctaPrimary} nav={content.nav} />
        <main>
          <BobHero hero={content.hero} />
          <BobDemo demo={content.demo} />
          <BobAudience audience={content.audience} />
          <BobValue value={content.value} trust={content.trust} />
          <BobFAQ faq={content.faq} />
          <BobContactCTA contact={content.contact} />
        </main>
        <Footer />
      </ChakraProvider>
    </>
  );
};

export default BobPage;
